import { API_URLS } from '../configuration/apiConstants';
import { apiFetch } from '../configuration/apiFetch';
import { useSessionStore } from '../store/sessionStore';


export const getStores =  () => {
  const fetchSettings = {
    method: "GET",
    url: API_URLS.STORES,
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      resolve(response)
    })
  })
  return dataFetch
}

export const getMotions =  (params) => {
  const fetchSettings = {
    method: "GET",
    url: API_URLS.MOTIONS,
    params
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      resolve(response)
    })
  })
  return dataFetch
}

export const getMotionsDynamic =  (params) => {
  const fetchSettings = {
    method: "GET",
    url: API_URLS.MOTIONS_DYNAMIC,
    params
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      resolve(response)
    })
  })
  return dataFetch
}

export const getStatistics =  () => {
  const myStore = useSessionStore.getState().myStore
  const fetchSettings = {
    method: "GET",
    url: API_URLS.STATISTICS(myStore?.id),
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      resolve(response)
    })
  })
  return dataFetch
}

export const getMotion =  (motionId) => {
  const myStore = useSessionStore.getState().myStore
  const fetchSettings = {
    method: "GET",
    url: API_URLS.MOTION(motionId),
    params: {storeId: myStore.id}
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      resolve(response)
    })
  })
  return dataFetch
}

export const getStoreMaps =  (storeId) => {
  const fetchSettings = {
    method: "GET",
    url: API_URLS.MAPS(storeId),
    params: {
      showImage: false
    }
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      const options = response.map(m => ({value: m.id, label: m.name}))
      resolve(options)
    })
  })
  return dataFetch
}